import { render, staticRenderFns } from "./IndexConfig.vue?vue&type=template&id=7ffdaeec&scoped=true&"
import script from "./IndexConfig.vue?vue&type=script&lang=js&"
export * from "./IndexConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffdaeec",
  null
  
)

export default component.exports